module.exports = __webpack_public_path__ + "static/media/992016.c5a53559.png";